import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from 'react';
import { CmsImage, type IndustryRelatedContent } from '../industries/IndustryPrimitives';
import styles from './RelatedIndustriesSection.module.css';
export type { IndustryRelatedCard, IndustryRelatedContent } from '../industries/IndustryPrimitives';
export function RelatedIndustriesSection(t0) {
  const $ = _c(10);
  const {
    content
  } = t0;
  const t1 = content.blockId;
  const t2 = `url(${content.backgroundImage})`;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      backgroundImage: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as CSSProperties;
  let t5;
  if ($[2] !== content.cards) {
    t5 = content.cards.map(_temp);
    $[2] = content.cards;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t5) {
    t6 = <div className={styles.relatedContainer}><div className={styles.relatedGrid}>{t5}</div></div>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== content.blockId || $[7] !== t4 || $[8] !== t6) {
    t7 = <section className={styles.relatedSection} data-cms-block-id={t1} style={t4}>{t6}</section>;
    $[6] = content.blockId;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}
function _temp(card, index) {
  return <a key={`${card.href}-${index}`} href={card.href} className={styles.relatedCard} data-cms-field={`cards.${index}`} style={{
    backgroundImage: `url(${card.backgroundImage})`
  } as CSSProperties}><div className={styles.relatedCardInner}><CmsImage image={card.icon} className={styles.relatedIcon} loading="lazy" sizes="52px" /><h5 className={styles.relatedTitle} data-cms-field={`cards.${index}.name`}>{card.name}</h5></div></a>;
}